import { render, staticRenderFns } from "./NftItemPool.vue?vue&type=template&id=2c64352d&scoped=true&"
import script from "./NftItemPool.vue?vue&type=script&lang=ts&"
export * from "./NftItemPool.vue?vue&type=script&lang=ts&"
import style0 from "./NftItemPool.vue?vue&type=style&index=0&id=2c64352d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64352d",
  null
  
)

export default component.exports